import { FileUpload } from "@/components/FileUpload";
import { Button } from "@/components/ui/button";
import { Upload, FolderOpen, Lock } from "lucide-react";
import { useState } from "react";
import DashboardHeader from "@/components/dashboard/DashboardHeader";
import OptionCard from "@/components/dashboard/OptionCard";
import FileManager from "@/components/dashboard/FileManager";
import DecryptSection from "@/components/dashboard/DecryptSection";

const Dashboard = () => {
  const [activeView, setActiveView] = useState<'select' | 'upload' | 'manage' | 'decrypt'>('select');

  const renderContent = () => {
    switch (activeView) {
      case 'select':
        return (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <OptionCard
              icon={Upload}
              title="Upload New File"
              description="Upload and encrypt new files securely"
              onClick={() => setActiveView('upload')}
            />
            <OptionCard
              icon={FolderOpen}
              title="Manage Files"
              description="View and manage your encrypted files"
              onClick={() => setActiveView('manage')}
            />
            <OptionCard
              icon={Lock}
              title="Decrypt Files"
              description="Decrypt and access your secured files"
              onClick={() => setActiveView('decrypt')}
            />
          </div>
        );

      case 'upload':
        return (
          <div className="space-y-4">
            <Button variant="outline" onClick={() => setActiveView('select')} className="mb-4">
              Back to Options
            </Button>
            <FileUpload />
          </div>
        );

      case 'manage':
        return <FileManager onBack={() => setActiveView('select')} />;

      case 'decrypt':
        return <DecryptSection onBack={() => setActiveView('select')} />;
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <DashboardHeader />
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-bold text-foreground mb-8 text-center">
            Secure File Management
          </h2>
          {renderContent()}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;